/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const da_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const de_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Art.-Nr.`
};

const en_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const es_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const fr_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Réf.`
};

const hu_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const it_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Rif.`
};

const nl_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const pl_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Nr ref.`
};

const pt_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

const sv_ref = /** @type {(inputs: {}) => string} */ () => {
	return `Ref.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ref = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ref(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ref", locale)
	if (locale === "cs") return cs_ref(inputs)
	if (locale === "da") return da_ref(inputs)
	if (locale === "de") return de_ref(inputs)
	if (locale === "en") return en_ref(inputs)
	if (locale === "es") return es_ref(inputs)
	if (locale === "fr") return fr_ref(inputs)
	if (locale === "hu") return hu_ref(inputs)
	if (locale === "it") return it_ref(inputs)
	if (locale === "nl") return nl_ref(inputs)
	if (locale === "pl") return pl_ref(inputs)
	if (locale === "pt") return pt_ref(inputs)
	return sv_ref(inputs)
};